import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-moving-truck-animation',
  templateUrl: './moving-truck-animation.component.html',
  styleUrls: ['./moving-truck-animation.component.scss']
})
export class MovingTruckAnimationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
